<template>
    <div class="border bg-gray-100 dark:bg-gray-700 dark:text-white rounded faq-item cursor-move p-4 mt-3">
        <div class="mb-4">Latest Articles</div>

        <Select
            label="Type"
            name="document_type"
            v-model="form.document_type"
            class="mt-2 col-span-3"
            :options="[
                { value: 'Blog', name: 'Blog' },
                { value: 'Guide', name: 'Guide' },
                { value: 'Casino Review', name: 'Casino Review' },
                { value: 'Game Review', name: 'Game Review' },
                { value: 'Slot Review', name: 'Slot Review' },
                { value: 'Category', name: 'Category' },
            ]"
            @input="() => {
                // can't use watch because it will be triggered when setForm is called by mounted, then tag will be null on load
                form.tag = null;
                form.tag_id = null;
                form.documents = [];
            }"
            :error="errorBag?.document_type ? errorBag.document_type[0] : null"
        />

        <div v-if="form.type_id"
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">Tag</p>
            <reference
                link-text="Link existing tags"
                :linkable="true"
                :creatable="false"
                :language="language"
                v-model="form.tag"
                field-name="tag"
                model-data="Tag"
                v-tooltip="{ content: 'Leave blank to select all tags', container: false, placement: 'top-start', html: false, }"
                :should-open-new-window="true"
                :query="{
                    type_id: form.type_id
                }"
            />
        </div>

        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 dark:text-white mb-4">Specify articles or leave empty for latest</p>
            <multi-reference
                link-text="Link specific articles"
                :linkable="true"
                :creatable="false"
                :language="language"
                v-model="form.documents"
                :should-open-new-window="true"
                :query="documents_query"
                :order="{
                    'name': 'asc'
                }"
                :model-data="form.document_type"
                :max-items="form.limit"
            />
        </div>

        <input-text
            label="Limit"
            name="limit"
            class="mt-3"
            type="number"
            :min="0"
            v-model="form.limit"
            v-tooltip="{ content: 'Leave blank to set unlimited', container: false, placement: 'top-start', html: false, }"
            :error="errorBag?.limit ? errorBag.limit[0] : null"
        />
    </div>
</template>

<script>
import draggable from "vuedraggable";
import siteLanguage from '../../config/siteLanguage'

const ARTICLE_TYPE_BLOG = 1;
const ARTICLE_TYPE_GUIDE = 2;

export default {
    components: { draggable },
    name: "LatestArticles",
    props: {
        value: {
            type: Object,
            required: true,
        },
        errorBag: {
            type: [Object, Array],
            required: false,
        },
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
    },
    data(){
        return {
            form: {
                document_type: 'Blog',
                type_id: ARTICLE_TYPE_BLOG,
                tag: null,
                tag_id: null,
                limit: null,
                documents: null,
            },
        }
    },
    mounted: function () {
        this.setForm();
    },
    computed: {
        documents_query: function () {
            const query = {
                'status_id': 1,
            };
            if (this.form.type_id != null && this.form.tag_id != null) {
                query['tags.tag_id'] = this.form.tag_id;
            }
            return query;
        },
    },
    methods: {
        setForm() {
            if (this.value && this.value.document_type) {
                this.form.document_type = this.value.document_type;
                this.form.type_id = this.value.document_type === 'Blog' ? ARTICLE_TYPE_BLOG : (this.value.document_type === 'Guide' ? ARTICLE_TYPE_GUIDE : null);

                this.form.tag = this.value.tag ?? null;
                if (this.form.tag_id != this.value.tag?.id) {
                    this.form.tag_id = this.value.tag?.id;
                    if (this.form.tag_id) {
                        this.form.documents = [];
                    }
                }

                this.form.documents = this.value.documents ?? null;
                this.form.limit = this.value.limit ? parseInt(this.value.limit) : null;
            }
        }
    },
    watch: {
        value: {
            deep: true,
            handler: function (newValue) {
                this.setForm();
            },
        },
        form: {
            deep: true,
            handler: function (newValue) {
                this.$emit('input', newValue);
            },
        },
    },
};
</script>
